/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import type { RepaymentProofDetail, RepaymentProofUploadResult } from '../types';
import { API_BASE_URL, requestBlob, requestJson } from './httpClient';

export const uploadRepaymentProof = async (params: {
  proof: Blob;
  proofFileName?: string;
  channelId?: number;
  repayAmount?: number;
  orderId?: string;
}) => {
  const formData = new FormData();
  formData.append('proof', params.proof, params.proofFileName || 'repayment_proof.jpg');
  if (typeof params.channelId === 'number') {
    formData.append('channelId', String(params.channelId));
  }
  if (typeof params.repayAmount === 'number') {
    formData.append('repayAmount', String(params.repayAmount));
  }
  if (params.orderId) {
    formData.append('orderId', params.orderId);
  }

  return requestJson<RepaymentProofUploadResult>(`${API_BASE_URL}/repayment-proof`, {
    method: 'POST',
    body: formData,
  });
};

export const fetchLatestRepaymentProof = async () =>
  requestJson<RepaymentProofDetail | null>(`${API_BASE_URL}/repayment-proof/latest`);

export const fetchRepaymentProofContent = async (proofId: number) =>
  requestBlob(`${API_BASE_URL}/repayment-proof/${proofId}/content`);
